/**
 * AlmadarPostStateSyncBrowserTabsENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostStateSyncBrowserTabsENPostPage
 */

import { useAlmadarPostStateSyncBrowserTabsENPostPageLogic } from '@/hooks/traits/useAlmadarPostStateSyncBrowserTabsENPostPageLogic';
import type { AlmadarPostStateSyncBrowserTabsENPostPageConfig } from '@/hooks/traits/useAlmadarPostStateSyncBrowserTabsENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostStateSyncBrowserTabsENPostView as AlmadarPostStateSyncBrowserTabsENPostViewEntity } from '@app/shared';
import { AlmadarPostStateSyncBrowserTabsENPostView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsENPostView';
import { Stack } from '@almadar/ui/components';
import { AlmadarPostStateSyncBrowserTabsENPostHeaderView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsENPostHeaderView';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostStateSyncBrowserTabsENPostFooterView } from '@/components/traits/AlmadarPostStateSyncBrowserTabsENPostFooterView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostStateSyncBrowserTabsENPostPageViewProps {
  config?: Partial<AlmadarPostStateSyncBrowserTabsENPostPageConfig>;
}

export function AlmadarPostStateSyncBrowserTabsENPostPageView({ config: propsConfig }: AlmadarPostStateSyncBrowserTabsENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostStateSyncBrowserTabsENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostStateSyncBrowserTabsENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostStateSyncBrowserTabsEN" trait="AlmadarPostStateSyncBrowserTabsENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostStateSyncBrowserTabsENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><AlmadarPostStateSyncBrowserTabsENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" fullWidth={true} paddingY="xl"><Container padding="lg" maxWidth="xl" size="xl"><AlmadarPostStateSyncBrowserTabsENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostStateSyncBrowserTabsENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostStateSyncBrowserTabsENPostPageView;
